import React from 'react';
import { Loader2 } from 'lucide-react';

const PostCardSkeleton = ({ postStatus, aspectRatio = '1:1' }) => {
  const statusLabel =
    postStatus === 'regeneration' || postStatus === 'regenerating'
      ? 'Regenerating post...'
      : postStatus === 'draft'
      ? 'Generating post...'
      : 'Loading post...';

  return (
    <div
      className='rounded-lg overflow-hidden flex flex-col h-full'
      style={{ background: 'var(--bg-card)', border: '1px solid var(--border)' }}
    >
      <div
        className='p-4 flex justify-between items-start'
        style={{ borderBottom: '1px solid var(--border)' }}
      >
        <div className='space-y-1'>
          <div className='skeleton h-5 w-24 rounded' />
          <div className='skeleton h-4 w-32 rounded' />
        </div>
        <div className='skeleton px-2 py-0.5 rounded h-5 w-12' />
      </div>

      <div
        className='flex-grow flex items-center justify-center p-6'
        style={{ background: 'var(--bg-surface)' }}
      >
        <div
          className={`w-full ${
            aspectRatio === '9:16' ? 'aspect-[9/16]' : 'aspect-[1/1]'
          } skeleton rounded-md relative overflow-hidden flex items-center justify-center`}
        >
          <div className='flex flex-col items-center justify-center gap-2'>
            <Loader2 className='w-10 h-10 animate-spin' style={{ color: 'var(--brand)' }} />
            <div className='text-sm font-medium' style={{ color: 'var(--text-muted)' }}>
              {statusLabel}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PostCardSkeleton;
